import { useState } from 'react'

import { addressOptions } from '@/DeliveryMethodsPage/AddressSuggestionDrawer/constants'
import { getDifferingAddressFields } from '@/DeliveryMethodsPage/hooks/useAddressValidation/helpers'

const useAddressSuggestionDrawer = ({ customerAddress, suggestedAddress, onConfirm, onClose }) => {
  const [selectedOption, setSelectedOption] = useState(addressOptions.suggested)

  const differingFields = suggestedAddress ? getDifferingAddressFields(customerAddress, suggestedAddress) : []

  const resetSelection = () => setSelectedOption(addressOptions.suggested)

  const confirmSelection = () => {
    onConfirm(selectedOption === addressOptions.suggested ? suggestedAddress : customerAddress)
    resetSelection()
  }

  const closeDrawer = () => {
    resetSelection()
    onClose()
  }

  return { selectedOption, selectOption: setSelectedOption, differingFields, confirmSelection, closeDrawer }
}

export default useAddressSuggestionDrawer
